<script context="module" lang="ts">
	// Adapted from <https://codepen.io/simeydotme/pen/yLqZdEG?editors=0110>
	function defaultExpiry(): string {
		const today = new Date();
		const month = String(today.getMonth() + 1);
		const nextYear = String(today.getFullYear() + 1);
		return `${month.padStart(2, '0')}/${nextYear.slice(-2)}`;
	}
</script>

<script lang="ts">
	export let number = '1234 1234 1234 1234';
	export let holder = 'john doe';
	export let expiry = defaultExpiry();
	export let perspectivePx = 1000;
	export let frame = 0.5
</script>

<div class="w-full aspect-[3/2] grid relative {$$props.class ?? ''}" style="perspective: {perspectivePx}px;">
	<div class="card-front font-mono w-full h-full" style="--frame: {frame}">
		<label class="number" for="cardNumber">{number}</label>
		<label class="name" for="cardHolder">{holder}</label>
		<label class="expiry" for="expiryMonth">{expiry}</label>

		<svg id="mastercard" xml:space="preserve" viewBox="0 0 999.2 776" class="cardLogo">
			<path
				id="XMLID_1775_"
				d="M181.1,774.3v-51.5c0-19.7-12-32.6-32.6-32.6  c-10.3,0-21.5,3.4-29.2,14.6c-6-9.4-14.6-14.6-27.5-14.6c-8.6,0-17.2,2.6-24,12v-10.3h-18v82.4h18v-45.5c0-14.6,7.7-21.5,19.7-21.5  s18,7.7,18,21.5v45.5h18v-45.5c0-14.6,8.6-21.5,19.7-21.5c12,0,18,7.7,18,21.5v45.5H181.1z M448.1,691.9h-29.2V667h-18v24.9h-16.3  v16.3h16.3v37.8c0,18.9,7.7,30,28.3,30c7.7,0,16.3-2.6,22.3-6l-5.2-15.5c-5.2,3.4-11.2,4.3-15.5,4.3c-8.6,0-12-5.2-12-13.7v-36.9  h29.2V691.9z M600.9,690.1c-10.3,0-17.2,5.2-21.5,12v-10.3h-18v82.4h18v-46.4c0-13.7,6-21.5,17.2-21.5c3.4,0,7.7,0.9,11.2,1.7  l5.2-17.2C609.4,690.1,604.3,690.1,600.9,690.1L600.9,690.1z M370,698.7c-8.6-6-20.6-8.6-33.5-8.6c-20.6,0-34.3,10.3-34.3,26.6  c0,13.7,10.3,21.5,28.3,24l8.6,0.9c9.4,1.7,14.6,4.3,14.6,8.6c0,6-6.9,10.3-18.9,10.3c-12,0-21.5-4.3-27.5-8.6l-8.6,13.7  c9.4,6.9,22.3,10.3,35.2,10.3c24,0,37.8-11.2,37.8-26.6c0-14.6-11.2-22.3-28.3-24.9l-8.6-0.9c-7.7-0.9-13.7-2.6-13.7-7.7  c0-6,6-9.4,15.5-9.4c10.3,0,20.6,4.3,25.8,6.9L370,698.7L370,698.7z M848.9,690.1c-10.3,0-17.2,5.2-21.5,12v-10.3h-18v82.4h18v-46.4  c0-13.7,6-21.5,17.2-21.5c3.4,0,7.7,0.9,11.2,1.7L861,691C857.5,690.1,852.4,690.1,848.9,690.1L848.9,690.1z M618.9,733.1  c0,24.9,17.2,42.9,43.8,42.9c12,0,20.6-2.6,29.2-9.4l-8.6-14.6c-6.9,5.2-13.7,7.7-21.5,7.7c-14.6,0-24.9-10.3-24.9-26.6  c0-15.5,10.3-25.8,24.9-26.6c7.7,0,14.6,2.6,21.5,7.7l8.6-14.6c-8.6-6.9-17.2-9.4-29.2-9.4C636.1,690.1,618.9,708.2,618.9,733.1  L618.9,733.1L618.9,733.1z M785.4,733.1v-41.2h-18v10.3c-6-7.7-14.6-12-25.8-12c-23.2,0-41.2,18-41.2,42.9c0,24.9,18,42.9,41.2,42.9  c12,0,20.6-4.3,25.8-12v10.3h18V733.1L785.4,733.1z M719.3,733.1c0-14.6,9.4-26.6,24.9-26.6c14.6,0,24.9,11.2,24.9,26.6  c0,14.6-10.3,26.6-24.9,26.6C728.8,758.8,719.3,747.6,719.3,733.1L719.3,733.1z M503.9,690.1c-24,0-41.2,17.2-41.2,42.9  c0,25.8,17.2,42.9,42.1,42.9c12,0,24-3.4,33.5-11.2l-8.6-12.9c-6.9,5.2-15.5,8.6-24,8.6c-11.2,0-22.3-5.2-24.9-19.7h60.9  c0-2.6,0-4.3,0-6.9C542.5,707.3,527,690.1,503.9,690.1L503.9,690.1L503.9,690.1z M503.9,705.6c11.2,0,18.9,6.9,20.6,19.7h-42.9  C483.3,714.2,491,705.6,503.9,705.6L503.9,705.6z M951.1,733.1v-73.8h-18v42.9c-6-7.7-14.6-12-25.8-12c-23.2,0-41.2,18-41.2,42.9  c0,24.9,18,42.9,41.2,42.9c12,0,20.6-4.3,25.8-12v10.3h18V733.1L951.1,733.1z M885,733.1c0-14.6,9.4-26.6,24.9-26.6  c14.6,0,24.9,11.2,24.9,26.6c0,14.6-10.3,26.6-24.9,26.6C894.4,758.8,885,747.6,885,733.1L885,733.1z M282.4,733.1v-41.2h-18v10.3  c-6-7.7-14.6-12-25.8-12c-23.2,0-41.2,18-41.2,42.9c0,24.9,18,42.9,41.2,42.9c12,0,20.6-4.3,25.8-12v10.3h18V733.1L282.4,733.1z   M215.5,733.1c0-14.6,9.4-26.6,24.9-26.6c14.6,0,24.9,11.2,24.9,26.6c0,14.6-10.3,26.6-24.9,26.6  C224.9,758.8,215.5,747.6,215.5,733.1z"
			/>
			<g>
				<rect id="rect19" x="364" y="66.1" fill="#FF5A00" width="270.4" height="485.8" />
				<path
					id="XMLID_330_"
					fill="#EB001B"
					d="M382,309c0-98.7,46.4-186.3,117.6-242.9   C447.2,24.9,381.1,0,309,0C138.2,0,0,138.2,0,309s138.2,309,309,309c72.1,0,138.2-24.9,190.6-66.1C428.3,496.1,382,407.7,382,309z"
				/>
				<path
					id="path22"
					fill="#F79E1B"
					d="M999.2,309c0,170.8-138.2,309-309,309   c-72.1,0-138.2-24.9-190.6-66.1c72.1-56.7,117.6-144.2,117.6-242.9S570.8,122.7,499.6,66.1C551.9,24.9,618,0,690.1,0   C861,0,999.2,139.1,999.2,309z"
				/>
			</g>
		</svg>

		<div class="chip">
			<svg role="img" viewBox="0 0 100 100" aria-label="Chip">
				<use href="#chip-lines" />
			</svg>
		</div>
		<svg class="contactless" role="img" viewBox="0 0 24 24" aria-label="Contactless">
			<use href="#contactless" />
		</svg>
	</div>
</div>

<svg id="chip">
	<g id="chip-lines">
		<polyline points="0,50 35,50" />
		<polyline points="0,20 20,20 35,35" />
		<polyline points="50,0 50,35" />
		<polyline points="65,35 80,20 100,20" />
		<polyline points="100,50 65,50" />
		<polyline points="35,35 65,35 65,65 35,65 35,35" />
		<polyline points="0,80 20,80 35,65" />
		<polyline points="50,100 50,65" />
		<polyline points="65,65 80,80 100,80" />
	</g>
</svg>

<svg id="contactless">
	<path stroke="none" d="M0 0h24v24H0z" fill="none" />
	<path d="M9.172 15.172a4 4 0 0 1 5.656 0" />
	<path d="M6.343 12.343a8 8 0 0 1 11.314 0" />
	<path d="M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0" />
</svg>

<style>
	:root {
		--duration: 6.66s;
	}

	.card-front:before {
		content: '';
		inset: 0;
		position: absolute;
		transform: translate3d(0, 0, 0.01px);
		background-image: url('/silver-glitter-background.webp'), url('/silver-glitter-background.webp'),
			linear-gradient(120deg, black 25%, white, black 75%);
		background-size: 100% 100%, 80% 80%, 200% 200%;
		background-blend-mode: multiply, multiply, overlay;
		background-position: 50% 50%, 50% 50%, 50% 50%;
		mix-blend-mode: color-dodge;
		filter: brightness(2) contrast(0.8);
		animation: bg 2s ease-in-out infinite;
		animation-play-state: paused;
		animation-delay: calc(var(--frame) * -1s);
	}

	.card-front {
		transform: translate3d(0, 0, 0.01px);
		border-radius: 3.5% 3.5% 3.5% 3.5% / 5% 5% 5% 5%;
		background-image: url(/pink-purple-waves.jpg);
		background-size: cover;
		box-shadow: 0 30px 40px -25px rgba(15, 5, 20, 1), 0 20px 50px -15px rgba(15, 5, 20, 1);
		overflow: hidden;
		animation: tilt 2s ease-in-out infinite;
        animation-play-state: paused;
		animation-delay: calc(var(--frame) * -1s);
		image-rendering: optimizequality;
	}

	.card-front:after {
		content: '';
		background: none, none,
			linear-gradient(
				125deg,
				rgba(255, 255, 255, 0) 0%,
				rgba(255, 255, 255, 0.4) 0.1%,
				rgba(255, 255, 255, 0) 60%
			);
		background-size: 200% 200%;
		mix-blend-mode: hard-light;
		animation: bg var(--duration) ease infinite;
	}

	.cardLogo,
	.expiry,
	.name,
	.number,
	.chip {
		color: #ccc;
		position: absolute;
		margin: 0;
		padding: 0;
		letter-spacing: 0.075em;
		text-transform: uppercase;
		font-size: clamp(0.75rem, 2.8vw + 0.2rem, 1.1rem);
		inset: 5%;
		text-shadow: -1px -1px 0px rgba(255, 255, 255, 0.5), 1px -1px 0px rgba(255, 255, 255, 0.5),
			1px 1px 0px rgba(0, 0, 0, 0.5), 1px -1px 0px rgba(0, 0, 0, 0.5);
		z-index: 5;
	}

	.name,
	.number,
	.expiry {
		background-image: linear-gradient(to bottom, #ededed 20%, #bababa 70%), none,
			linear-gradient(120deg, transparent 10%, white 40%, white 60%, transparent 90%);
		background-size: cover, cover, 200%;
		background-position: 50% 50%;
		background-blend-mode: overlay;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		-webkit-background-clip: text;
		animation: bg var(--duration) ease infinite;
	}

	.number {
		text-align: center;
		letter-spacing: 0.025em;
		top: 60%;
	}

	.expiry,
	.name {
		top: auto;
	}

	.name {
		right: auto;
		max-width: 180px;
		line-height: 1.2;
		text-align: left;
	}

	.expiry {
		left: auto;
	}

	.cardLogo {
		bottom: auto;
		left: auto;
		width: 15%;
		filter: invert(1) saturate(0) brightness(1) contrast(1.2);
		mix-blend-mode: screen;
	}

	.chip {
		display: grid;
		place-items: center;
		width: 14%;
		aspect-ratio: 5/4;
		left: 10%;
		top: 30%;
		border-radius: 10% 10% 10% 10% / 15% 15% 15% 15%;
		background-image: none, none, linear-gradient(120deg, #777 10%, #ddd 40%, #ddd 60%, #777 90%);
		background-size: 200% 200%;
		background-position: 50% 50%;
		overflow: hidden;
		animation: bg var(--duration) ease infinite;
	}

	.chip svg {
		display: block;
		width: 90%;
		fill: none;
		stroke: #444;
		stroke-width: 2;
	}

	.contactless {
		position: absolute;
		left: 23%;
		top: 30%;
		width: 12%;
		rotate: 90deg;
		stroke-width: 1.25;
		stroke: currentColor;
		fill: none;
		stroke-linecap: round;
		stroke-linejoin: round;
		opacity: 0.5;
	}

	@keyframes tilt {
		0%,
		100% {
			transform: translate3d(0, 0, 0.01px) rotateY(-20deg) rotateX(5deg);
		}
		50% {
			transform: translate3d(0, 0, 0.01px) rotateY(20deg) rotateX(5deg);
		}
	}

	@keyframes bg {
		0%,
		100% {
			background-position: 50% 50%, calc(50% + 1px) calc(50% + 1px), 0% 50%;
		}
		50% {
			background-position: 50% 50%, calc(50% - 1px) calc(50% - 1px), 100% 50%;
		}
	}

	#chip,
	#contactless {
		display: none;
	}
</style>
